// removed by extract-text-webpack-plugin
module.exports = {"box":"qempo_Feedback_box-2zw0U4c","disabled":"qempo_Feedback_disabled-tEFmfwm","loading":"qempo_Feedback_loading-2WwWDQ-","yogiPaw":"qempo_Feedback_yogiPaw-2K5MmcL","feedback":"qempo_Feedback_feedback-nw5K_o4","thumbWrap":"qempo_Feedback_thumbWrap-B4mMIOX","selected":"qempo_Feedback_selected-2rKIa8k","bad":"qempo_Feedback_bad-3q_-7Ag","good":"qempo_Feedback_good-1FXSfY6","socialBlock":"qempo_Feedback_socialBlock-3jkBhBT","title":"qempo_Feedback_title-3htDPpO","feedbackModal":"qempo_Feedback_feedbackModal-15mexM5"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/order/Purchase/feedback/components/Feedback.scss
// module id = 1862
// module chunks = 0